<template>
    <div class="mobile-search-container">
        <div :class="formClass" v-if="show">
            <div class="form-wrapper clearfix">
                <label class="d-inline-block d-sm-none">
                    <i class="icon-search"></i>
                </label>
                <form class="form-inline">
                    <input type="text" class="form-control" placeholder="Vpišite kaj iščete ..." name="search" @keyup="search" v-model="query" ref="input">
                </form>
                <label @click="toggleForm">
                    <i class="icon-close"></i>
                </label>
            </div>
            <header-search-results v-if="results && results.length" :results="results" :query="query" width="12"></header-search-results>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import HeaderSearchResults from './HeaderSearchResults.vue'

export default {

    components: {
        HeaderSearchResults
    },

    props: {
        src: {
            default: '/search'
        }
    },

    data() {
        return {

            show: false,
            query: null,
            results: null

        }
    },

    computed: {

        formClass() {
            return 'search-form' + (this.show ? ' show' : '');
        }

    },

    methods: {

        toggleForm() {

            this.show = ! this.show;

            // Focus field if shown else clear results
            if (this.show) {
                Vue.nextTick(() => this.$refs.input.focus());
            } else {
                this.results = null;
                this.query = null;
            }
        },

        search() {

            let query = this.query;

            if (query.length >= 2) {
                new App.xhr({query}).post(this.src).then(results => this.results = results);
            } else {
                this.results = null;
            }

        }

    },

    mounted() {
        App.dispatcher.listen('mobile-search.open', () => {
            this.show = true;
            Vue.nextTick(() => this.$refs.input.focus());            
        });

        [].forEach.call(document.querySelectorAll('*[data-role="mobile-search.open"]'), (el) => {
            el.addEventListener('click', () => {
                App.dispatcher.fire('mobile-search.open');
            }, false);
        });
    }
  
}
</script>
